export default __webpack_public_path__ + "static/media/bihorel.bbb34490.jpg";